import { ArrowRightCircle } from "lucide-react";
import React, { useState } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import { GoDotFill } from "react-icons/go";
import { Link } from "react-router-dom";
// import FeatureCard from "./featuredCard";

const SectionThree = () => {
  const [bgImageOne, setBgImageOne] = useState("./assets/dark.svg");
  const [bgImageTwo, setBgImageTwo] = useState("./assets/green.svg");
  const [bgImageThree, setBgImageThree] = useState("./assets/greenet.svg");
  return (
    <div className="px-6 py-8 md:px-16 md:py-26 lg:px-16  xl:px-32 xl:py-32">
      <div className="flex flex-col items-center justify-center gap-4 md:gap-8 lg:gap-6">
        <button className="flex items-center justify-center gap-1 text-[#32AE4C] border border-[#32AE4C] tracking-wider px-2 md:px-4 py-1 md:py-1 lg:py-1 rounded-full text-xs md:text-xs  xl:text-sm ">
          <GoDotFill className="w-3 h-3  lg:w-4 lg:h-4" />
          <p className="whitespace-now-rap"> Features & Services</p>
        </button>
        <p className="font-semibold text-center mt-2 md:mt-4 text-sm md:text-xl lg:text-2xl xl:text-3xl">
          An All-in-One Finance Ecosystem Built <br /> for Individuals and
          Businesses
        </p>
        <p className="font-inter text-xs md:text-2xl lg:text-base xl:text-sm text-center text-gray-400">
          A Unified Platform for Personal and Business Success
        </p>
      </div>

      <div className="flex flex-col gap-y-4 md:gap-y-10 lg:gap-y-0">
        <div className="flex flex-col md:flex-row mt-8 py-0 lg:py-2  overflow-hidden gap-4 md:gap-8 lg:gap-4">
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            className="animate__animated  animate__delay-1s animate__slower w-full md:w-[60%]"
          >
            <div
              className=" relative rounded-3xl py-5 px-[16px] md:p-10 lg:p-10 lg:px-6 h-[300px] md:h-[360px]"
              style={{
                backgroundImage: `url('${bgImageOne}')`,
                backgroundPosition: "center 100%",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                transition: "background-image 1s ease-out",
              }}
            >
              <div className="flex justify-center items-center ">
                <img
                  src={"./assets/cam.svg"}
                  alt="group-img"
                  fill
                  className=" w-[70%] lg:w-[50%] h-[80px] lg:h-[100px] xl:h-[120px]"
                />
              </div>

              <div className="text-white flex flex-col justify-between h-[65%] pt-4 pb-2 md:pb-4 md:pt-4 lg:pt-6 lg:pb-0 ">
                <p className="text-lg md:text-xl lg:text-2xl leading-tight md:leading-snug ">
                  Virtual Dollar & Naira Expense Cards
                </p>
                <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                  Issue virtual USD or NGN cards for your team, set per‑card
                  spend limits, view real‑time transactions, and instantly block
                  or replace cards.
                </p>
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3 ">
                  <Link
                    to="https://business.vant.ng/signup"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <button className="border-none text-sm md:text-sm lg:text-base xl:text-base font-semibold ">
                      Get Started Now
                    </button>
                  </Link>
                                  <ArrowRightCircle color="white" className="h-4" />

                </div>
              </div>
            </div>
          </ScrollAnimation>

          <div
            className="w-full md:w-[40%] relative rounded-[18px] md:rounded-3xl py-7 md:py-8 lg:py-10 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageTwo}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-end items-end ">
              <img
                src={"./assets/savetarget.svg"}
                alt="group-img"
                className=" w-[70%] lg:w-[45%] h-[80px] lg:h-[100px] xl:h-[120px]"
              />
            </div>
            <div className="text-white mt-4 flex flex-col justify-between h-[50%] px-4 md:px-5 xl:px-6  ">
              <p className="text-lg md:text-xl lg:text-2xl  leading-tight md:leading-snug ">
                Save, Transfer and Invest
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Whether you prepare for the future or not, it doesn’t prevent
                the future from evolving. Get intentional about your personal
                finances
              </p>
              <div className="flex items-center gap-2 md:gap-4 lg:gap-3  ">
                <Link
                  to="https://business.vant.ng/signup"
                  rel="noreferrer"
                  target="_blank"
                >
                  <button className="border-none text-sm md:text-sm lg:text-base xl:text-base font-semibold ">
                    Get Started Now
                  </button>
                </Link>
                                <ArrowRightCircle color="white" className="h-4" />

              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row-reverse mt-0 lg:mt-8 py-0 lg:py-2  gap-4 md:gap-8 lg:gap-4 ">
          <div
            className="w-full md:w-[60%] relative rounded-[18px] md:rounded-3xl py-7 md:py-8 lg:py-10 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center ">
              <img
                src={"./assets/shane.svg"}
                alt="group-img"
                className="relative w-[70%] lg:w-[50%] h-[90px] lg:h-[120px] xl:h-[140px]"
              />
            </div>

            <div className="text-white mt-4 flex flex-col justify-between h-[50%] px-4 md:px-5 xl:px-6  ">
              <p className="text-lg md:text-xl lg:text-2xl  leading-tight md:leading-snug ">
                Book Keeping
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                {" "}
                Auto‑categorize transactions, reconcile accounts in real time,
                generate profit & loss, balance sheet reports, and export to
                your favorite accounting software.
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3  ">
                  <button className="border-none text-sm md:base lg:text-base  font-semibold ">
                    Get Started Now
                  </button>
                                  <ArrowRightCircle color="white" className="h-4" />

                </div>
              </Link>
            </div>
          </div>

          <div
            className="w-full md:w-[40%] relative rounded-3xl py-8 md:py-18 lg:py-10 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageTwo}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center ">
              <img
                src={"./assets/prof.svg"}
                alt="group-img"
                className="relative w-[70%] lg:w-[50%] h-[90px] lg:h-[130px] "
              />
            </div>

            <div className="text-white mt-4 md:mt-6 flex flex-col justify-between h-[55%] px-4 md:px-5 xl:px-6  ">
              <p className="text-lg md:text-xl lg:text-2xl  leading-tight md:leading-snug ">
                Invoicing & Payments
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Create professional invoices in seconds, send payment links via
                email or SMS, and track receivables—automated reminders help you
                get paid faster.
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3  ">
                  <button className="border-none text-sm md:base lg:text-base  font-semibold ">
                    Get Started Now
                  </button>
                                  <ArrowRightCircle color="white" className="h-4" />

                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* --------------------------- */}

        <div className="flex flex-col md:flex-row mt-8 py-0 lg:py-2  gap-4 md:gap-8 lg:gap-4">
          <div
            className="w-full md:w-[60%] relative rounded-3xl py-5 px-[16px] md:p-10 lg:p-10 lg:px-6 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center ">
              <img
                src={"./assets/grouptwo.svg"}
                alt="group-img"
                className="relative w-[70%] lg:w-[50%] h-[80px] lg:h-[100px] xl:h-[120px]"
              />
            </div>

            <div className="text-white flex flex-col justify-between h-[65%] pt-4 pb-2 md:pb-4 md:pt-4 lg:pt-6 lg:pb-0 ">
              <p className="text-lg md:text-xl lg:text-2xl leading-tight md:leading-snug ">
                Bulk Payout Solutions
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Disburse salaries, vendor fees, or refunds in a single batch,
                reducing administrative overhead and payment errors; ideal for
                payroll and event settlements
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3 ">
                  <button className="border-none text-sm md:text-sm lg:text-base xl:text-base font-semibold ">
                    Get Started Now
                  </button>
                                   <ArrowRightCircle color="white" className="h-4" />

                </div>
              </Link>
            </div>
          </div>

          <div
            className="w-full md:w-[60%] relative rounded-3xl py-8 md:py-8 lg:py-10 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageTwo}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-end items-center lg:items-end ">
              <img
                src={"./assets/inventory.png"}
                alt="group-img"
                className="relative h-[80px] lg:h-[100px] xl:h-[120px]"
              />
            </div>
            <div className="text-white mt-4 flex flex-col justify-between h-[50%] px-4 md:px-5 xl:px-6  ">
              <p className="text-lg md:text-xl lg:text-2xl leading-tight md:leading-snug ">
                Store & Inventory
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Manage stock levels, orders, and suppliers in real time never
                run out or overstock.
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                {" "}
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3  ">
                  <button className="border-none text-sm md:base lg:text-base  font-semibold ">
                    Get Started Now
                  </button>
                 <ArrowRightCircle color="white" className="h-4" />
                </div>
              </Link>
            </div>
          </div>
        </div>

        {/* <div className="flex flex-col md:flex-row mt-8 py-0 lg:py-2  gap-4 md:gap-8 lg:gap-4">
          <div
            className="w-full md:w-[60%] relative rounded-3xl py-5 px-[16px] md:p-10 lg:p-10 lg:px-6 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageOne}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center ">
              <img
                src={"./assets/grouptwo.svg"}
                alt="group-img"
                className="relative w-[70%] lg:w-[50%] h-[80px] lg:h-[100px] xl:h-[120px]"
              />
            </div>

            <div className="text-white flex flex-col justify-between h-[65%] pt-4 pb-2 md:pb-4 md:pt-4 lg:pt-6 lg:pb-0 ">
              <p className="text-lg md:text-xl lg:text-2xl leading-tight md:leading-snug ">
                Dollar & Pound Wallets
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Hold and manage foreign currency balances to hedge against Naira
                volatility and pay international suppliers directly
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3 ">
                  <button className="border-none text-sm md:text-sm lg:text-base xl:text-base font-semibold ">
                    Get Started Now
                  </button>
                  <img
                    src={"./assets/arrow.svg"}
                    alt="arrow-img"
                    className="h-4 w-4 md:h-7 md:w-7 lg:h-6 lg:w-6"
                  />
                </div>
              </Link>
            </div>
          </div>

          <div
            className="w-full md:w-[60%] relative rounded-3xl py-8 md:py-8 lg:py-10 h-[300px] md:h-[360px]"
            style={{
              backgroundImage: `url('${bgImageTwo}')`,
              backgroundPosition: "center 100%",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              transition: "background-image 1s ease-out",
            }}
          >
            <div className="flex justify-center items-center lg:items-end ">
              <img
                src={"./assets/account_statement.png"}
                alt="group-img"
                className="relative  h-[80px] lg:h-[100px] xl:h-[120px]"
              />
            </div>
            <div className="text-white mt-4 flex flex-col justify-between h-[50%] px-4 md:px-5 xl:px-6  ">
              <p className="text-lg md:text-xl lg:text-2xl leading-tight md:leading-snug ">
                Transaction Statements
              </p>
              <p className="text-sm  w-[100%]  lg:w-[90%] xl:w-[85%]">
                Generate detailed statements by date range or project to feed
                directly into your accounting system, ensuring accurate records
                and audit readiness
              </p>
              <Link
                to="https://business.vant.ng/login"
                rel="noreferrer"
                target="_blank"
              >
                {" "}
                <div className="flex items-center gap-2 md:gap-4 lg:gap-3  ">
                  <button className="border-none text-sm md:base lg:text-base  font-semibold ">
                    Get Started Now
                  </button>
                  <img
                    src={"./assets/arrow.svg"}
                    alt="arrow-img"
                    className="h-4 w-4 md:h-7 md:w-7 lg:h-6 lg:w-6"
                  />
                </div>
              </Link>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default SectionThree;
